/**
 * Lisans Helper Fonksiyonları
 * Backend proxy üzerinden uzak lisans sunucusu ile iletişim
 * Cloudflare uyumlu - DNS sorunlarını backend proxy ile çözer
 */

import { getApiUrl, API_ENDPOINTS } from '../config/apiConfig';

/**
 * Lisans sunucusu API URL'ini döndürür
 */
export const getLicenseServerUrl = (endpoint = '') => {
  return getApiUrl(API_ENDPOINTS.CHECK_LICENSE);
};

/**
 * Dijital imzayı doğrular
 * NOT: Bu basit bir doğrulama. Gerçek imza doğrulaması sunucu tarafında yapılır.
 * Burada sadece yanıtın yapısını kontrol ederiz.
 */
export const verifySignature = (response) => {
  if (!response || typeof response !== 'object') {
    return false;
  }
  
  if (response.success === true && 
      response.data && 
      response.signature && 
      response.timestamp && 
      response.nonce) {
    const now = Math.floor(Date.now() / 1000);
    const timestamp = response.timestamp;
    const timeDiff = Math.abs(now - timestamp);
    
    if (timeDiff > 300) {
      return false;
    }
    
    return true;
  }
  
  if (response.success === false) {
    return true;
  }
  
  return false;
};

export const activateLicense = async (licenseKey, domain) => {
  try {
    const response = await fetch(getLicenseServerUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        license_key: licenseKey.trim(),
        domain: domain
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (data.success && data.license_info) {
      return {
        success: true,
        message: data.message || 'Lisans başarıyla aktifleştirildi',
        license: data.license_info
      };
    } else {
      return {
        success: false,
        message: data.message || 'Lisans aktivasyonu başarısız'
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error.message || 'Lisans sunucusuna bağlanılamadı'
    };
  }
};

export const validateLicense = async (licenseKey, domain) => {
  try {
    const response = await fetch(getLicenseServerUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        license_key: licenseKey.trim(),
        domain: domain
      })
    });

    if (!response.ok) {
      return false;
    }

    const data = await response.json();
    
    if (data.success && data.license_info && data.license_info.is_active) {
      return true;
    }
    
    return false;
  } catch (error) {
    console.warn('License validation error:', error);
    return false;
  }
};

export const deactivateLicense = async (licenseKey, domain) => {
  try {
    const response = await fetch(getLicenseServerUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        license_key: licenseKey.trim(),
        domain: domain
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    return {
      success: data.success || false,
      message: data.message || 'Lisans devre dışı bırakıldı'
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || 'Lisans sunucusuna bağlanılamadı'
    };
  }
};

/**
 * Offline mod kontrolü
 * Son başarılı doğrulama 6 saatten eskiyse false döner
 * NOT: Sadece network hatası durumunda kullanılır, inactive durumunda kullanılmaz
 */
export const isOfflineModeValid = (lastValidation) => {
  if (!lastValidation) {
    return false;
  }
  
  const lastValidationTime = new Date(lastValidation).getTime();
  const now = Date.now();
  const sixHours = 6 * 60 * 60 * 1000;
  
  return (now - lastValidationTime) < sixHours;
};

/**
 * Sunucu kontrolü gerekli mi?
 * Son başarılı doğrulama 6 saatten eskiyse true döner
 */
export const shouldCheckServer = (lastValidation) => {
  if (!lastValidation) {
    return true;
  }
  
  const lastValidationTime = new Date(lastValidation).getTime();
  const now = Date.now();
  const sixHours = 6 * 60 * 60 * 1000;
  
  return (now - lastValidationTime) >= sixHours;
};
